import { ReferralCodeValidation } from "@decibeltrade/sdk";
import { type FetchQueryOptions, useQuery } from "@tanstack/react-query";

import { readDexSdk } from "../../dex-sdk";

export function isValidRefCodeQueryKey(code: string) {
  return ["isValidRefCode", code] as const;
}

export function isValidRefCodeQuery(code: string) {
  return {
    queryKey: isValidRefCodeQueryKey(code),
    queryFn: () => readDexSdk.referrals.validateCode(code),
  } satisfies FetchQueryOptions<ReferralCodeValidation>;
}

export function useIsValidRefCodeQuery(code: string | undefined) {
  return useQuery({
    ...isValidRefCodeQuery(code ?? ""),
    enabled: !!code,
  });
}
